// import { ref, computed } from "vue";
import { defineStore } from "pinia";

export type ChatInfo = {
  id: string;
  type?: number;
  publicId?: string;
  favIconUrl?: string;
  title?: string;
  description?: string;
  displayPictrue?: string;
  email?: string;
  url?: string;
  loading?: boolean;
  createTime?: string;
};

export const useChatStore = defineStore("chat", {
  state: () => ({
    sessionId: "",
    info: { id: "" } as ChatInfo,
  }),
  getters: {},
  actions: {
    setSessionInfo(info: ChatInfo) {
      this.info = info;
      if (info.id) this.setSessionId(info.id);
    },

    setSessionId(sessionId: string) {
      this.sessionId = sessionId;
    },
  },
});
